<template>
     <div class="toggle-cgv" style="
               font-family: 'Helvetica';
               font-size: 0.8em;
               display: flex;
               align-items: center;
               flex-direction: row;
          ">
          <button :style="[CGVButtonStyle, { background: activate ? 'rgb(15, 76, 133)' : 'transparent' }]"
               @click="toggleTrigger">
               <i class="material-icons" style="font-size: 1em; font-weight: 900; color: white;">check</i>
          </button>
          <input type="checkbox" id="toggle-cgv" @change="toggleTrigger" style="display: none;">
          <label for="toggle-cgv" style="margin: 1px 1px 1px 5px;">
               <span class="toggle-cgv__text">{{ this.$i18n.t('text.accept_cgv') }}{{ " " }}</span>
               <a href="https://www.formacast.org/_files/ugd/a8e3dc_7dd886cd7cd44182ae09c06195cf4207.pdf"
                    target="_blank">{{ this.$i18n.t('text.click_here') }}
               </a>
          </label>
     </div>

</template>

<script>
import { customLogger } from '@/utils';
export default {
     data() {
          return {
               test: true,
               CGVButtonStyle: {
                    height: '25px !important',
                    width: '35px !important',
                    border: '1.5px solid rgb(15, 76, 133)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                    borderRadius: '3px',
               }
          };
     },
     created() {
     },
     props: {
          activate: {
               type: Boolean,
               default: false
          },
     },
     methods: {
          toggleTrigger() {
               this.$emit('update:CGV', this.activate);
          }
     }
};
</script>